import { combineReducers } from 'redux';
import loginForm from './LoginFormState';
import loading from './UILoadState';
import faxes from './Faxes';
import users from './Users';
import numbers from './Numbers';
import companies from './Companies';
import epikBoxes from './EpikBoxes';
import epikBoxDetails from './EpikBoxDetails';
import obis from './Obis';
import proposalEditor from './ProposalEditor';
import proposals from './Proposals';
import modifyProducts from './ModifyProducts';
import analytics from './Analytics';
import calls from './Calls';
import profile from './Profile';
import provisioning from './Provisioning';
import steps from './Breadcrumbs';
import toggleCollapse from './ToggleCollapse';
import inteliquent from './Inteliquent';
import globals from './Globals';

export default combineReducers({
  globals,
  loginForm,
  faxes,
  users,
  loading,
  numbers,
  companies,
  epikBoxes,
  epikBoxDetails,
  obis,
  proposalEditor,
  proposals,
  modifyProducts,
  analytics,
  calls,
  profile,
  provisioning,
  steps,
  toggleCollapse,
  inteliquent,
});
